import { FounderLevel, Milestone } from "@/types/levels";

export const getRevenueThreshold = (level: FounderLevel): number => {
  switch (level) {
    case FounderLevel.STACK_CERTIFIED:
      return 0;
    case FounderLevel.STACK_PRO:
      return 10000;
    case FounderLevel.STACK_X:
      return 100000;
    default:
      return 0;
  }
};

export const getMilestonesForLevel = (
  level: FounderLevel,
  allMilestones: Milestone[],
): Milestone[] => {
  switch (level) {
    case FounderLevel.STACK_CERTIFIED:
      // Show only the foundational milestones for Stack Certified
      return allMilestones.filter((m) =>
        ["define-niche", "demo-approved", "playbook-completed"].includes(m.id),
      );
    case FounderLevel.STACK_PRO:
      // Show only the additional milestones needed for Stack Pro (beyond Stack Certified)
      return allMilestones.filter((m) =>
        ["billing-10k", "testimonials-2"].includes(m.id),
      );
    case FounderLevel.STACK_X:
      // Show only the additional milestones needed for Stack X (beyond Stack Pro)
      return allMilestones.filter((m) =>
        ["billing-100k", "testimonials-5", "unique-clients-5"].includes(m.id),
      );
    default:
      return [];
  }
};

export const getCurrentRevenue = (milestones: Milestone[]): number => {
  const billingMilestone = milestones.find(
    (m) => m.id === "billing-10k" || m.id === "billing-100k",
  );
  return billingMilestone?.progress || 0;
};
